import { render, staticRenderFns } from "./loginInput.vue?vue&type=template&id=5c31f6af&scoped=true&"
import script from "./loginInput.vue?vue&type=script&lang=js&"
export * from "./loginInput.vue?vue&type=script&lang=js&"
import style0 from "./loginInput.vue?vue&type=style&index=0&id=5c31f6af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31f6af",
  null
  
)

export default component.exports